module.exports = __webpack_public_path__ + "static/media/pharma.ec8c05b1.png";